import React, { useEffect, useState } from "react";
import { getTodayComplaintNotifications } from "../../../services/AdminService";

const NotificationAdmin = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const res = await getTodayComplaintNotifications();
        if (res.status) {
          setNotifications(res.admin_notification || []);
        } else {
          setNotifications([]);
        }
      } catch (error) {
        console.error("Error fetching complaint notifications:", error);
        setNotifications([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []);

  return (
    <div className="container my-4">
      <div className="card shadow">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">📢 Today's  Notifications</h5>
        </div>
        <div className="card-body">
          {loading ? (
            <p>Loading...</p>
          ) : notifications.length === 0 ? (
            <p className="text-muted">No new notifications for today.</p>
          ) : (
            <ul className="list-group">
              {notifications.map((msg, idx) => (
                <li key={idx} className="list-group-item">
                  <i className="fas fa-bell me-2 text-primary"></i> {msg}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationAdmin;
